import { render } from "./RegisterContent.vue?vue&type=template&id=454ea3c3&ts=true"
import script from "./RegisterContent.vue?vue&type=script&lang=ts"
export * from "./RegisterContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__